import { AVideoAspectRatio, AVideoType, type AVideoProps } from '../../atoms/AVideo/AVideo.types';
import { MButtonOverlayProps } from '../MButtonOverlay/MButtonOverlay.types';

export enum MVideoBackgroundButtonPosition {
  Bottom = 'Bottom',
  Top = 'Top',
}

export enum MVideoBackgroundErrorMessage {
  Default = 'Unable to load video',
}

export enum MVideoBackgroundAriaLabel {
  Pause = 'Pause video',
  Play = 'Play video',
}

export interface MVideoBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonPosition?: MVideoBackgroundButtonPosition;
  aVideo: AVideoProps;
  mButtonOverlay?: MButtonOverlayProps & {
    imageOverlay?: 'True' | 'False' | boolean;
  };
}

export { AVideoType, AVideoAspectRatio };
export type MVideoBackgroundButtonPositionType = MVideoBackgroundButtonPosition;
